module.exports = __webpack_public_path__ + "static/media/ice.8cafde28.glb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Models/ice.glb
// module id = 1331
// module chunks = 1 4 6 19 21 23